import { Fragment } from 'react';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

export type TypeProps = NodeProps<{
  bold?: boolean;
  children: StructuredContent | StructuredContent[];
  italic?: boolean;
}> & { nested?: boolean };

export function Type({ nested = false, props }: TypeProps) {
  const Tag = props.bold ? 'strong' : nested ? 'span' : 'p';

  return (
    <Tag
      className={[
        'typography-body',
        'whitespace-pre-line',
        props.bold && '!font-bold',
        props.italic && 'italic',
      ]
        .filter(Boolean)
        .join(' ')}
      style={{
        fontSize: props.bold ? 'inherit' : 'initial',
        fontWeight: props.bold ? undefined : 'inherit',
      }}
    >
      {[props.children].flat().map((child, index) => {
        if (typeof child === 'string') {
          if (child === '\n') return <br key={index} />;
          return <Fragment key={index}>{child}</Fragment>;
        }
        if (child) return <StructuredContentRenderer doc={child} nested key={index} />;
        return null;
      })}
    </Tag>
  );
}
